module.exports = __webpack_public_path__ + "static/media/ai3si.6df25b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sites/ai3si.png
// module id = 318
// module chunks = 0